import Vue from 'vue';
import animations from '@itbpbg/lms-components/src/plugins/animations';

Vue.directive('visible', (el, binding) => {
  // eslint-disable-next-line no-param-reassign
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});

Vue.use(animations);
